<template>
  <div>
    <div class="max-w-7xl mx-auto px-4 sm:px-6" ref="tnav">
      <nav
        class="relative flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:justify-between sm:h-10 md:justify-center"
        aria-label="Global"
      >
        <div
          class="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0"
        >
          <div class="flex items-center justify-between w-full md:w-auto">
            <router-link to="/" class="flex items-center">
              <span class="sr-only">Rayfish</span>
              <img class="h-8 w-auto -mt-1.5" src="@/assets/logo.png" alt="" />
              <span
                class="ml-4 text-zinc-200 font-logo text-base tracking-normal"
                >Rayfish</span
              >
            </router-link>
          </div>
        </div>
        <div
          class="flex w-full items-center justify-between gap-3 sm:w-auto sm:gap-6 md:absolute md:justify-end md:inset-y-0 md:right-0"
        >
          <router-link
            to="/manymux"
            class="inline-flex min-h-[44px] items-center text-sm font-semibold text-zinc-300 transition-colors hover:text-white sm:text-base"
            >manymux</router-link
          >
          <router-link
            to="/blog"
            class="inline-flex min-h-[44px] items-center text-sm font-semibold text-zinc-300 transition-colors hover:text-white sm:text-base"
            >Blog</router-link
          >
          <router-link
            :to="docsTo"
            class="inline-flex min-h-[44px] items-center text-sm font-semibold text-zinc-300 transition-colors hover:text-white sm:text-base"
            >Docs</router-link
          >
          <span class="inline-flex rounded-full">
            <a
              href="https://github.com/rayfish/rayfish"
              target="_blank"
              rel="noopener"
              class="inline-flex items-center gap-2 rounded-full border border-transparent bg-zinc-100 px-3 py-3 sm:px-4 sm:py-2 text-sm font-semibold text-zinc-900 transition duration-300 hover:bg-white"
            >
              <svg
                class="h-4 w-4"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                />
              </svg>
              GitHub
            </a>
          </span>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    // "Docs" means the docs for whatever you are looking at. Anywhere under
    // /manymux that is the manymux book, so the link does not throw you out of
    // the product you came in for.
    docsTo() {
      const path = this.$route.path;
      const inManymux = path === "/manymux" || path.startsWith("/manymux/");
      return inManymux ? "/manymux/docs" : "/docs";
    },
  },
};
</script>
